import React from 'react'
import cx from 'classnames'

import { Box } from 'components/_new/layout'
import type { BoxProps } from 'components/_new/layout'

import s from './Card.scss'


export type CardShadow = 'cold-10' | 'cold-32' | 'warm-10' | 'warm-32' | 'warm-with-hover' | 'cold-with-hover'

type CardProps = BoxProps & {
  shadow?: CardShadow
  fullHeight?: boolean
  withBorder?: boolean
}

const Card: React.FunctionComponent<CardProps> = (props) => {
  const { children, className, shadow, fullHeight, withBorder, ...boxProps } = props

  const rootClassName = cx(className, s.card, {
    [s[`shadow-${shadow}`]]: shadow,
    [s.fullHeight]: fullHeight,
    [s.withBorder]: withBorder,
  })

  return (
    <Box
      className={rootClassName}
      {...boxProps}
    >
      {children}
    </Box>
  )
}


export default Card
